import { render, staticRenderFns } from "./123.vue?vue&type=template&id=72d329d9&scoped=true&"
var script = {}
import style0 from "./123.vue?vue&type=style&index=0&id=72d329d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d329d9",
  null
  
)

export default component.exports